import React, { useEffect, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TriStateCheckbox } from "primereact/tristatecheckbox";
import { classNames } from "primereact/utils";
import { TableControlStyled } from "./styled";
import { Button } from "primereact/button";

const TableControl = ({
  title ='',
  items,
  filter,
  columns,
  emptyMessage,
  isExportExcel,
  fileName,
  loading,
  rows,
  onPage,
  rowsPerPageOptions = undefined,
  paginator = true,
  setFilteredData,
}) => {
  const [datos, setDatos] = useState(items);
  const verifiedRowFilterTemplate = (options) => {
    return (
      <TriStateCheckbox
        value={options.value}
        onChange={(e) => options.filterApplyCallback(e.value)}
      />
    );
  };

  useEffect(() => {
    setDatos(items);
  }, [items]);

  const verifiedBodyTemplate = (rowData, item) => {
    return (
      <i
        className={classNames("pi", {
          "true-icon pi-check-circle": rowData[item.fieldName],
          "false-icon pi-times-circle": !rowData[item.fieldName],
        })}
      ></i>
    );
  };
  const saveAsExcelFile = (buffer) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(data, fileName + EXCEL_EXTENSION);
      }
    });
  };
  const applyCustomFilters = (items, filters) => {
    return items.filter((item) => {
      return Object.entries(filters).every(([field, filterMeta]) => {
        const value = item[field]?.toString().toLowerCase() ?? "";
        const filterValue = filterMeta?.value?.toString().toLowerCase() ?? "";
        const matchMode = filterMeta?.matchMode;

        if (!filterValue) return true; // sin filtro en este campo

        if (matchMode === "contains") {
          return value.includes(filterValue);
        }

        return true; // puedes extender para otros matchMode
      });
    });
  };

const handleFilter = (e) => {
  const filtered = applyCustomFilters(items, e.filters);
  
  // Si no se encontró nada, mostrar la lista original
  const dataToShow = filtered.length === 0 ? items : filtered;

  setDatos(dataToShow);

  if (setFilteredData) {
    // Aquí puedes decidir si quieres pasar `[]` o también `items`
    setFilteredData(filtered.length === 0 ? [] : filtered);
  }
};


  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const exportedColumns = columns.filter((column) => !column.noExported);



      const customizedItems = datos.map((item) => {
        const customizedItem = {};
        exportedColumns.forEach((column) => {
          customizedItem[column.name] = item[column.fieldName];
        });
        return customizedItem;
      });

      const worksheet = xlsx.utils.json_to_sheet(customizedItems, {
        header: exportedColumns.map((column) => column.name),
      });

      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "customizedFile");
    });
  };

  const header = (
    <div className="flex align-items-center export-buttons">
      <Button
        type="button"
        icon="pi pi-file-excel"
        onClick={exportExcel}
        className="p-button-success mr-2"
        data-pr-tooltip="XLS"
      />
    </div>
  );

  return (
    <TableControlStyled>
      <div className="card">
        <h5>{title}</h5>
        {datos.length > 0 && (
          <DataTable
            loading={loading}
            value={datos}
            paginator={paginator}
            className="p-datatable-customers"
            rows={rows ? rows : 10}
            dataKey="id"
            size="small"
            filters={filter}
            filterDisplay="row"
            header={isExportExcel ? header : null}
            responsiveLayout="scroll"
            onPage={onPage}
            onFilter={handleFilter}
            currentPageReportTemplate={500}
            rowsPerPageOptions={rowsPerPageOptions}
            // globalFilterFields={filterFields}
            emptyMessage={emptyMessage ? emptyMessage : " "}
          >
            {columns &&
              columns.map((item, index) => {
                if (!item.noVisible) {
                  return item.isFilter ? (
                    item.isBoolean ? (
                      <Column
                        key={index}
                        {...item}
                        field={item.fieldName}
                        header={item.name}
                        dataType="boolean"
                        style={{ minWidth: "6rem" }}
                        body={(rowData) => {
                          if (item.body) {
                            return item.body(rowData);
                          } else {
                            return verifiedBodyTemplate(rowData, item);
                          }
                        }}
                        filter
                        filterElement={(options) =>
                          verifiedRowFilterTemplate(options, item)
                        }
                      />
                    ) : (
                      <Column
                        {...item}
                        key={index}
                        field={item.fieldName}
                        header={item.name}
                        filter
                        filterPlaceholder={item.filterPlaceHolder}
                        style={{ minWidth: item.width }}
                      />
                    )
                  ) : item.isBoolean ? (
                    <Column
                      {...item}
                      key={index}
                      field={item.fieldName}
                      header={item.name}
                      dataType="boolean"
                      style={{ minWidth: "6rem" }}
                    />
                  ) : item.body ? (
                    <Column
                      {...item}
                      key={index}
                      field={item.fieldName}
                      header={item.name}
                      style={{ minWidth: item.width }}
                      body={item.body}
                    />
                  ) : (
                    <Column
                      key={index}
                      {...item}
                      field={item.fieldName}
                      header={item.name}
                      style={{ minWidth: item.width }}
                    />
                  );
                }
              })}
          </DataTable>
        )}
      </div>
    </TableControlStyled>
  );
};

export default TableControl;
